import { PageError, Panel } from '@cmg/common';
import { DataGridContextProvider } from '@cmg/data-grid';
import React from 'react';

import { useDocumentTitle } from '../../../common/hooks/useDocumentTitle/useDocumentTitle';
import routeFactory from '../../../common/util/routeFactory';
import { useTraitList_AccountTraitsQuery } from './components/trait-list/graphql';
import TraitList from './components/trait-list/TraitList';
import type { AccountTrait } from './components/trait-list/TraitList.model';

export const TraitListRouteComponent: React.FC = () => {
  useDocumentTitle(routeFactory.adminTraits.getDocumentTitle());
  const { data, error, loading } = useTraitList_AccountTraitsQuery();

  if (error) {
    // eslint-disable-next-line
    // TODO: update PageError to take ApolloError as prop
    const errObj = {
      code: '',
      message: error.message,
      target: '',
      details: [],
    };
    return <PageError error={errObj} />;
  }

  const traits = data?.accountTraits as AccountTrait[] | undefined;

  return (
    <React.Fragment>
      <Panel fillViewport>
        <Panel.Header title="Traits" />
        <TraitList loading={loading} traits={traits} />
      </Panel>
    </React.Fragment>
  );
};

const TraitListRoute: React.FC = () => {
  return (
    <DataGridContextProvider>
      <TraitListRouteComponent />
    </DataGridContextProvider>
  );
};

export default TraitListRoute;
